import React from 'react';
import { Reveal } from './Reveal';
import { AffiliateCTA } from './AffiliateCTA';
import { AFFILIATE_DISCLOSURE } from '../data/affiliate';
import type { PillarPageContent } from '../types/pillarPage';
type FinalCTAProps = {
  content: PillarPageContent['finalCta'];
  affiliateUrl: string;
};
export function FinalCTA({
  content,
  affiliateUrl
}: FinalCTAProps) {
  return <section id="cta-final" className="relative w-full overflow-hidden bg-ink py-32 lg:py-44" data-id="element-43" data-mp="87joi5o7tye4">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[880px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/[0.07] blur-[170px]" aria-hidden="true" data-id="element-44" data-mp="m2lustwz5prg" />

      <div className="relative mx-auto w-full max-w-[880px] px-6 text-center sm:px-10" data-id="element-45" data-mp="qvood21r4z7n">
        <Reveal data-id="element-46" data-mp="qy17hij8xfma">
          <h2 className="text-3xl font-extrabold leading-[1.07] tracking-[-0.03em] text-bone sm:text-5xl lg:text-[3.6rem]" data-id="element-47" data-mp="14v6htupzt0nc">
            {content.headlineTop}
            <span className="block text-accent" data-id="element-48" data-mp="zy6cxn4vq3xt">{content.headlineAccent}</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-49" data-mp="2c6rc6bq0skpp">
          <p className="mx-auto mt-8 max-w-xl text-[15px] leading-relaxed text-ash sm:text-base" data-id="element-50" data-mp="2h3hruxxwxeal">
            {content.paragraph}
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-51" data-mp="2m4xakjcmb8pt">
          <div className="mt-12 flex flex-col items-center" data-id="element-52" data-mp="2r1npv4glm0a6">
            <AffiliateCTA label={content.ctaLabel} href={affiliateUrl} className="w-full sm:w-auto" data-id="element-53" data-mp="2r38lyyik9ra5" />
            <p className="mt-6 text-[13px] text-ash" data-id="element-54" data-mp="301tzgf96eg42">{content.subnote}</p>
            <p className="mx-auto mt-10 max-w-md text-[11px] leading-relaxed text-ash/45" data-id="element-55" data-mp="34tby2wnq84lv">
              {AFFILIATE_DISCLOSURE}
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}